{
    "webhooks": {
        "newWebhook": "Nouveau Webhook",
        "name": "Nom du Webhook",
        "description": "Description",
        "editWebhook": "Modifier le Webhook",
        "webhookDetails": "Détails du Webhook",
        "messages": {
            "deleteWebhookConfirmation": "Voulez-vous supprimer le webhook {webhookName} ?",
            "deleteWebhookSuccess": "Webhook supprimé avec succès",
            "webhookNameExists": "Le nom du webhook {webhookName} existe déjà",
            "webhookNameRequired": "Le nom du webhook est requis",
            "workflowRequired": "Sélectionnez un flux de travail dans le menu déroulant",
            "copied": "Copié dans le presse-papiers",
            "copyError": "Échec de la copie",
            "success": "Webhook enregistré avec succès",
            "errorOccurred": "Une erreur s'est produite lors de l'enregistrement du webhook"
        },
        "title": "Webhooks",
        "webhookName": "Nom du Webhook",
        "workflow": "Flux de travail",
        "webhookUrl": "URL du Webhook",
        "tokenUrl": "URL du Webhook (avec token)",
        "triggerHelp": "Envoyez une requête POST à l'URL ci-dessous pour déclencher ce flux de travail.",
        "basicAuthFallback": "Utiliser Basic Auth à la place",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "token": "Jeton",
        "active": "Actif",
        "inactive": "Inactif",
        "restrictedAccess": "Accès restreint",
        "invalidWorkflow": "Flux de travail invalide",
        "activateSuccess": "Webhook activé avec succès",
        "deactivateSuccess": "Webhook désactivé avec succès",
        "createWebhook": "Créer un Webhook",
        "noWebhooks": "Aucun webhook configuré pour ce flux de travail"
    },
    "groups": {
        "title": "Groupes",
        "noGroupedFields": "Aucun champ groupé trouvé",
        "newGroup": "Nouveau Groupe",
        "editGroup": "Modifier le Groupe",
        "workflows": "Workflows",
        "groupName": "Nom du Groupe",
        "roles": "Rôles",
        "selectWorkflows": "Sélectionner les Workflows",
        "tooltip": "Sélectionnez l'ordre des workflows à afficher dans le VXL Live",
        "selected": "Workflows Sélectionnés",
        "workflowName": "Nom du Workflow",
        "createdByUser": "Créé Par",
        "modifiedBy": "Modifié Par",
        "created": "Créé",
        "modified": "Modifié",
        "messages": {
            "groupNameRequired": "Le nom du groupe est requis.",
            "groupNameExists": "Le groupe {groupName} existe déjà !",
            "groupNameCheckFailed": "Impossible de vérifier le nom du groupe. Veuillez réessayer.",
            "rolesRequired": "Au moins un rôle doit être sélectionné.",
            "deleteGroupConfirmation": "Êtes-vous sûr de vouloir supprimer le groupe '{groupName}' ?",
            "deleteGroupSuccess": "Groupe supprimé avec succès.",
            "success": "Groupe enregistré avec succès.",
            "workflowsRequired": "Au moins un workflow doit être sélectionné."
        }
    },
    "workflows": {
        "openReadOnly": "Ouvrir en lecture seule",
        "readOnly": {
            "label": "Lecture seule",
            "description": "La configuration de cette étape ne peut pas être modifiée. Sélectionnez et copiez une valeur, ou copiez toute la configuration.",
            "copyConfiguration": "Copier la configuration",
            "copySuccess": "Configuration de l’étape copiée dans le presse-papiers.",
            "copyError": "Impossible de copier la configuration de l’étape."
        },
        "active": "Actif Workflow",
        "search": "Rechercher par nom ou ID",
        "importWorkflow": "Importer Workflow",
        "importWorkflowTooltip": "Lorsque cette option est sélectionnée, ce workflow est configuré pour importer/téléverser des données depuis un tableur Excel lors de l'exécution. Le workflow traitera les données téléversées et déclenchera les API associées. Ces API peuvent effectuer des opérations d'importation ou d'exportation selon la configuration du workflow.",
        "unsavedPopover": {
            "title": "Modifications non sauvegardées",
            "message": "Vous avez des modifications non sauvegardées dans le workflow \"{title}\". Voulez-vous sauvegarder le workflow ?",
            "saveAndContinue": "Sauvegarder et continuer"
        },
        "addUserInstructions": "Ajouter un nouveau",
        "addCustomStatus": "Ajouter un statut personnalisé",
        "allWorkflows": "Tous les workflows",
        "designFile": "Fichier de conception",
        "designFileSaved": "Fichier de conception mis à jour avec succès",
        "lookupWorkflow": "<strong>Nom de la recherche :</strong> {lookup}   <strong>Nom du workflow :</strong> {workflow}",
        "type": "Type de flux de travail",
        "nameIsRequired": "Le nom est requis",
        "nameNotPermitted": "Vous n'avez pas la permission de créer un workflow avec ce nom",
        "nameHasSpecialChars": "Les caractères spéciaux : / $ * ? {'{'} {'}'} [ ] & % ne sont pas autorisés",
        "api": {
            "addApi": "Ajouter API",
            "alreadyExists": "already exists!",
            "apiOptions": "Options API",
            "basedOnTransaction": "Basé sur la transaction",
            "code": "Code",
            "componentSettings": "Paramètres des composants",
            "connections": "Connections",
            "constant": "Constant",
            "critical": "Critique",
            "currentDate": "Date Actuelle",
            "done": "Terminé",
            "editElement": "Modifier l'élément",
            "endRun": "Moyen détourné",
            "enterRows": "Entrer des lignes",
            "enterValue": "Entrez la valeur",
            "environment": "Environment",
            "fromApi": "De l'API",
            "fromClient": "Du client",
            "fromEvent": "From Event",
            "fromExcel": "Depuis Excel",
            "fromTag": "de Tag",
            "group": "Groupe",
            "groupedBy": "Groupé par",
            "includeGeneralTransactions": "Inclure les transactions générales",
            "input": "Input",
            "inputs": "Contributions",
            "mapped": "Mappé",
            "max": "Max",
            "maxRows": "Lignes max",
            "messages": {
                "configureOneTransaction": "API: Configure at least one Transaction",
                "mandatoryFieldNotMapped": "API: Mandatory field not mapped: {input}"
            },
            "configurationExecutionKeys": "Clés d’exécution de configuration ({current}/{maximum})",
            "keyName": "Nom",
            "expression": "Expression JSONata",
            "addNewExecutionKey": "Nouvelle clé",
            "validation": {
                "keyNameRequired": "Le nom de la clé est requis",
                "invalidExpression": "Expression JSONata invalide",
                "expressionRequired": "L’expression est requise"
            },
            "name": "Nom",
            "output": "Production",
            "outputs": "Les sorties",
            "overview": "Aperçu",
            "pleaseEnterValue": "Veuillez saisir une valeur",
            "program": "Programme",
            "programName": "Nom du programme",
            "runOn": "Courir",
            "select": "Select",
            "selectSource": "Sélectionner la source",
            "source": "La source",
            "startRun": "Démarrer Exécuter",
            "transaction": "Transaction",
            "transactionName": "Nom de la transaction",
            "view": "Vue",
            "workflowSpreadsheet": "Le flux de travail utilise des données de feuille de calcul?"
        },
        "notification": {
            "status": {
                "finished": "terminé",
                "started": "démarré",
                "stepcomplete": "en cours",
                "failed": "échoué"
            },
            "view": "Voir",
            "workflow": "Workflow {workflowName} {status}"
        },
         "runWorkflow": {
            "errors": {
                "hasError": "Le workflow contient des erreurs de configuration",
                "noEnvironments": "Aucun environnement disponible pour l'exécution",
                "connectionsLoadFailed": "Échec du chargement des connexions",
                "environmentsLoadFailed": "Échec du chargement des environnements",
                "noConnections": "Aucune connexion disponible pour l'exécution"
            },
            "execute": "Exécuter",
             "tooltips": {
                "openLookupDialog": "Ouvrir la boîte de dialogue de recherche"
            }
        },
        "cancelEditor": "Annuler",
        "clientConfig": {
            "buttonDefaultText": "Exécuter",
            "descriptionDefaultText": "Description",
            "legacyDescriptionDefaultText": "Description",
            "legacyTitleDefaultText": "Untitled",
            "titleDefaultText": "Nouveau modèle"
        },
        "client": {
            "addFilterInput": "Ajouter une entrée de filtre",
            "addInput": "Ajouter une entrée",
            "apiDetails": "Détails de API",
            "browseControl": "Contrôle de Feuilleter",
            "buttonText": "Texte du bouton",
            "changeText": "changement de texte",
            "clientConfiguration": "Configuration du client",
            "clientSettings": "Paramètres du client",
            "customRequired": "Rendre obligatoire",
            "dateField": "Champ de date",
            "defaultValue": "Valeur par défaut",
            "fields": "Champs",
            "input": "Contribution",
            "lookup": "Chercher",
            "placeholder": "Endroit titulaire",
            "settings": "Paramètres",
            "tagField": "Tag",
            "textField": "Champ de texte",
            "title": "Client",
            "tooltip": "Info-bulle",
            "type": "Type"
        },
        "closeConfirmation": "Voulez-vous enregistrer les modifications en attente?",
        "closeConfirmationTitle": "Veuillez confirmer",
        "closeEditor": "Fermer",
        "code": {
            "codeEditor": "Code editor"
        },
        "component": "Composant",
        "componentSettings": "Paramètres des composants",
        "components": "Composants",
        "connection": "Lien",
        "createdBy": "Created by",
        "createdDate": "Date de création",
        "m3Fetch": {
            "title": "M3 Fetch",
            "messages": {
                "configureOneOutputPerTransaction": "FETCH : Veuillez configurer au moins une sortie par transaction"
            }
        },
        "dataLake": {
            "title": "Data lake",
            "connectionId": "Connexion",
            "connectionPlaceholder": "Sélectionner ou saisir un ID de connexion...",
            "endpoint": "URL du point de terminaison",
            "endpointPlaceholder": "https://api.example.com/path",
            "body": "Requête",
            "bodyPlaceholder": "Saisissez votre requête...",
            "advanced": "Avancé",
            "saveAsFile": "Enregistrer également la sortie en fichier"
        },
        "fileUploader": {
            "messages": {
                "connectionRequired": "La connexion est requise",
                "itemRequired": "Le chemin est requis"
            },
            "title": "Téléverseur de fichiers",
            "connection": "Connexion",
            "webUrl": "Chemin",
            "browse": "Parcourir"
        },
        "transformerMorph": {
            "inputOrTemplateMissing": "Veuillez fournir les données d'entrée et le modèle JSONATA",
            "title": "Transformation",
            "input": "Entrée",
            "output": "Sortie",
            "help": "Apprendre la syntaxe JSONATA",
            "executionId": "ID d'exécution du workflow",
            "executionIdPrompt": "Charger des données d'exemple et simuler $context avec les valeurs réelles d'une exécution de workflow",
            "transformation": "Expression JSONATA",
            "loadExecution": "Charger",
            "executionIdSuccessMessage": "Données chargées avec succès pour l'ID d'exécution {executionId}",
            "noExecutionFound": "Aucune exécution de workflow trouvée",
            "executionIdErrorMessage": "Erreur lors du chargement de l'exécution",
            "copyToClipboard": "Copier dans le presse-papiers",
            "copySuccessMessage": "Expression JSONata copiée dans le presse-papiers",
            "copyErrorMessage": "Erreur lors de la copie de l'expression JSONata dans le presse-papiers"
        },
        "saveError": "Erreur lors de l'enregistrement du workflow",
        "genericFilter": {
            "filterFieldPlaceholder": "Spécifier {fact} pour filtrer"
        },
        "genericCode": {
            "title": "Éditeur de code d'étape"
        },
        "genericApi": {
            "title": "Rest API",
            "version": "Version",
            "versionDescription": "Version du composant",
            "connection": "Utiliser une connexion",
            "connectionId": "Connexion",
            "connectionPlaceholder": "Sélectionner ou saisir un ID de connexion...",
            "endpoint": "URL du point de terminaison",
            "endpointPlaceholder": "https://api.example.com/path",
            "method": "Méthode HTTP",
            "methodWarning": "Méthode inconnue. Attendu une méthode HTTP standard ou une expression handlebars",
            "headers": "En-têtes",
            "addHeader": "Ajouter un en-tête",
            "headerKey": "Clé",
            "headerValue": "Valeur",
            "bodyMode": "Corps de la requête",
            "bodyModeOption": {
                "bodyPath": "Body path",
                "body": "Body"
            },
            "bodyPathDescription": "Référencer les données d'une étape précédente",
            "bodyDescription": "Définir le corps de la requête",
            "bodyPathLabel": "Expression JSONata du body path",
            "bodyLabel": "Corps de la requête JSON",
            "advanced": "Avancé",
            "skipIfExpression": "Ignorer si expression",
            "skipIfExpressionDescription": "Une expression JSONata qui, si elle est évaluée à vrai, ignorera cette étape",
            "forEach": "Pour chaque",
            "forEachDescription": "Chemin vers un tableau d'une étape précédente à parcourir (ex. body.records)",
            "parallel": "Exécutions parallèles",
            "parallelDescription": "Nombre de requêtes simultanées à exécuter en parallèle (max 20)",

            "bodyEncoding": "Envoyer les données encodées en base64 en tant que binaire",

            "bodyEncodingDescription": "Cochez cette case lorsque le corps contient un fichier stocké sous forme de texte (base64)"
        },
        "runtimeConfig": {
            "title": "Configurer les environnements d'exécution",
            "connectionAliases": "Alias de connexion",
            "connectionAliasesHelp": "Chaque système est résolu à l'exécution vers la connexion mappée pour l'environnement sélectionné.",
            "alias": "Système",
            "aliasPlaceholder": "Ajouter un autre système",
            "aliasValidation": "Seuls les lettres minuscules, chiffres et underscores sont autorisés",
            "aliasDuplicate": "Ce système existe déjà",
            "addAlias": "Ajouter un système",
            "environments": "Environnements",
            "default": "Par défaut",
            "setDefault": "Définir par défaut",
            "connections": "Mappages de connexions",
            "selectConnection": "Sélectionner connexion...",
            "noAliasesYet": "Aucun alias de connexion défini pour l'instant. Ajoutez d'abord des alias ci-dessus.",
            "variables": "Variables",
            "variableKey": "Clé",
            "variableValue": "Valeur",
            "addEnvironmentPlaceholder": "Ajouter un environnement...",
            "emptyState": "Ajoutez un environnement pour commencer. Les connexions seront détectées automatiquement.",
            "noDefinitionError": "Le workflow n'a pas de définition, impossible de sauvegarder."
        },
        "deleteAPI": "Supprimer l'API",
        "deleteComponent": "Supprimer le composant",
        "deleteItem": "Êtes-vous sûr de vouloir supprimer \"{workflowName}\"?",
        "deleteItemFromDashboard": "Êtes-vous sûr de vouloir supprimer \"{workflowName}\"? Ce workflow est connecté au tableau de bord et {widgetCount} {widgetText}.",
        "deleteConfirmation": "Confirmation de suppression",
        "deleteItemAPI": "Voulez-vous supprimer l'API {APIName}?",
        "deleteUserInstructions": "Supprimer",
        "deleteUserInstructionsConfirmationMessage": "Cette action supprimera définitivement les instructions utilisateur. Êtes-vous certain de vouloir continuer ?",
        "deleteUserInstructionsConfirmationTitle": "Confirmer la suppression",
        "deleteLastStepError": "La dernière étape du flux de travail ne peut pas être supprimée. \n Ajoutez d'abord une autre étape ou supprimez le flux de travail entier.",
        "description": " workflow La description",
        "editor": {
            "addComponent": "Ajouter un composant",
            "api": "API",
            "code": "Code",
            "componentToStartWorkflow": "Sélectionnez un composant pour démarrer à partir du flux de travail",
            "converter": "Converter",
            "createFromScratch": "...Ou créer à partir de zéro",
            "createFromTemplate": "Créer à partir d'un modèle...",
            "dataLake": "Data lake",
            "database": "Base de données",
            "email": "Email",
            "excel": "Exceller",
            "exportToExcel": "Exporter depuis M3",
            "fileLoader": "File Loader",
            "filter": "Filtre",
            "genericFilter": "Filtre générique",
            "importToAPI": "Importer vers M3",
            "lookup": "Lookup",
            "notification": "Notification",
            "restApi": "Rest API",
            "sms": "SMS",
            "storeApiToTable": "Stocker les données de M3 dans la table",
            "table": "Table",
            "tableUpdater": "Table updater",
            "transform": "Transform",
            "trigger": "Trigger",
            "widget": "Widget"
        },
        "email": {
            "sourceType": {
                "NONE": "Aucun",
                "FILE": "Fichiers générés",
                "DATA": "Données brutes"
            },
            "noFileSourceSteps": "Aucune étape précédente ne peut produire de fichier",
            "sourceTypeHint": {
                "FILE": "Joindre un fichier produit par une étape antérieure compatible (ex. {stepNames})",
                "DATA": "Joindre les données brutes d'une étape antérieure au format JSON"
            },
            "body": "Corps",
            "sourceStep": "Étape source pour les données",
            "noSourceSteps": "Aucune étape source pouvant produire des données n'est disponible",
            "addresses": "Adresses",
            "content": "Contenu de l'e-mail",
            "attachment": "Pièces jointes",
            "isHTML": "HTML",
            "htmlHelp": "Doit être sélectionné si l'utilisateur utilise du code HTML dans les étapes Transform ou Email.",
            "editorTabs": {
                "visual": "Éditeur visuel",
                "html": "Éditeur HTML",
                "preview": "Aperçu"
            },
            "toolbar": {
                "heading": "Titre",
                "subheading": "Sous-titre",
                "normal": "Normal"
            },
            "attachmentIndicators": {
                "none": "--",
                "data": "<>"
            },
            "subject": "Objet",
            "invalidEmail": "E-mail invalide",
            "to": "À",
            "addCc": "Ajouter des adresses cc",
            "cc": "Cc",
            "bcc": "Cci",
            "addBcc": "Ajouter des adresses cci",
            "title": "Expéditeur de l'e-mail",
            "fieldNames": {
                "toAddress": "Adresse du destinataire",
                "subject": "Objet",
                "body": "Corps"
            },
            "requiredFieldsWarning": "Veuillez remplir {fields} ou supprimer l'étape d'e-mail.",
            "errorMissingFields": "E-MAIL : Champs manquants : {fields}"
        },
        "enterDescription": "Entrez la description",
        "enterEmail": "Enter email",
        "enterName": "Entrez le nom",
        "environment": "Environnement",
        "event": {
            "eventConfiguration": "Event Configuration",
            "title": "Event"
        },
        "excel": {
            "selectAll": "Tout sélectionner",
            "showSelected": "Afficher la sélection",
            "fromSource": "Depuis {source}",
            "chooseTheFile": "Choose a new file",
            "columnStyleApplied": "Style de colonne appliqué à la colonne",
            "columnToLeft": "Ajouter une colonne à gauche",
            "columnToRight": "Ajouter une colonne à droite",
            "controlSpreadSheet": "contrôler la feuille de calcul",
            "descriptionRow": "Ligne de description",
            "mappingRow": "Ligne de mappage",
            "dataRow": "Ligne de données",
            "unsetMappingRow": "Démarquer comme ligne de mappage",
            "setMappingRow": "Marquer comme ligne de mappage",
            "setDescriptionRow": "Marquer comme ligne de description",
            "deleteCell": "Supprimer la cellule",
            "deleteConfirmation": "Confirmation de suppression",
            "deleteContent": "Supprimer le contenu",
            "deleteDesignFile": "Supprimer le fichier de conception",
            "deleteDesignFileConfirmation": "Veuillez confirmer si vous souhaitez continuer et supprimer définitivement le fichier de conception.",
            "deleteInputItem": "Voulez-vous supprimer {item} de la section de mappage de l'éditeur d'API?",
            "deleteOutputItem": "Voulez-vous supprimer {item} du mappage?",
            "designFileAlert": "Confirmez votre téléchargement en enregistrant le workflow",
            "endColumn": "colonne de fin",
            "enforceSheetVerification": "Appliquer la vérification des feuilles",
            "environment": "Show used environment on execution",
            "environmentMessageColumn": "Environment Message Column",
            "excelSetting": "Excel réglage",
            "excelSettings": "Paramètres",
            "importWorkflowRequiredMessage": "Pour utiliser le mappage Excel des données d’entrée, ce workflow doit être configuré en tant que workflow d’importation.\nSouhaitez-vous activer le workflow d’importation ?",
            "groupBy": "Group by",
            "headerRow": "Ligne d'en-tête",
            "input": "Saisir",
            "messages": {
                "mapField": "EXCEL: Map {input} field for excel",
                "mapOneInputFieldExcel": "EXCEL: Veuillez mapper au moins un champ de saisie pour excel",
                "mapOneOutputFieldExcel": "EXCEL: Veuillez mapper au moins un champ de sortie pour excel"
            },
            "next": "Prochain",
            "options": "Options",
            "output": "Production",
            "removeGroupBy": "Remove group by",
            "removeSortBy": "Remove sort by",
            "removeTargetSheet": "Remove Feuille cible",
            "rowStyleApplied": "Style de ligne appliqué à la ligne",
            "saveBackup": "Enregistrer la sauvegarde de la sortie",
            "secondaryHeaderRow": "Ligne d'en-tête secondaire",
            "selectDifferentSheets": "Please select different sheets as Source and target Sheet",
            "sheetName": "Nom de la feuille",
            "sortBy": "Sort by",
            "sourceSheet": "Fiche source",
            "startColumn": "Colonne de départ",
            "style": "Style",
            "styleHeader": "Appliquer le style à l'en-tête",
            "targetSheet": "Feuille cible",
            "title": "Excel",
            "toggleHeader": "Basculer l'en-tête",
            "twoHeaders": "Deux en-têtes",
            "upload": "Upload",
            "showMappingValues": "Afficher les valeurs de mappage",
            "hideMappingValues": "Masquer les valeurs de mappage",
            "horizontalNoLeftColumn": "La disposition horizontale nécessite une colonne à gauche de la cellule de dépôt pour l'étiquette du champ",
            "workflow": "Flux de travail",
            "workflowMessageColumn": "Colonne de message de workflow",
            "template": {
                "singleHeader": "Un en-tête",
                "doubleHeader": "Deux en-têtes"
            },
            "preview": {
                "sourceSheet": "Feuille source",
                "headerRow": "Mapping row",
                "secondaryHeaderRow": "Description row",
                "dataRow": "Ligne de données",
                "applyTooltip": "Les lignes de mappage ou de description ont été modifiées. Cliquez ici pour relancer le mappage automatique.",
                "startColumn": "Colonne de début",
                "endColumn": "Colonne de fin",
                "targetSheet": "Feuille cible",
                "addTargetSheet": "Ajouter une feuille cible",
                "removeTargetSheet": "Supprimer une feuille cible",
                "targetSheetWarning": "Les feuilles source et cible ne peuvent pas être identiques. Veuillez sélectionner des feuilles différentes pour la source et la cible.",
                "sheetView": "Vue feuille",
                "sourceLabel": "Source",
                "targetLabel": "Cible",
                "validation": {
                    "headerOrMappingRequired": "Au moins l'une des lignes Description ou Mappage est requise.",
                    "headerAndMappingSameRow": "Les lignes Description et Mappage ne peuvent pas être identiques.",
                    "dataRowAfterHeader": "La ligne de données doit se trouver après la ligne Description.",
                    "dataRowAfterMapping": "La ligne de données doit se trouver après la ligne Mappage.",
                    "applyRowsZero": "Les numéros de ligne ne doivent pas être nuls ou inférieurs à zéro.",
                    "applyRowsConflict": "La ligne de données doit venir après les lignes Description et Mappage.",
                    "unappliedRowChangesSource": "L'onglet Source a des modifications de lignes non appliquées. Veuillez cliquer sur ✓ pour les appliquer.",
                    "unappliedRowChangesTarget": "L'onglet Cible a des modifications non appliquées. Passez à l'onglet Cible et cliquez sur ✓ pour les appliquer.",
                    "unappliedRowChangesBoth": "Les onglets Source et Cible ont des modifications non appliquées. Cliquez sur ✓ dans chaque onglet pour les appliquer."
                }
            },
            "editCell": "Modifier la cellule",
            "largeColumnCountWarning": "Vous avez mappé un grand nombre de colonnes ({count}). Cela peut dépasser les limites du système et provoquer l'échec de l'enregistrement."
        },
        "m3Api": {
            "unmappedRequiredInputs": "Les entrées obligatoires suivantes ne sont pas mappées : {inputs}",
            "removeStartEnd": "Désactiver début-fin",
            "addStartEnd": "Activer début-fin",
            "updateGrouping": "Regroupement supplémentaire",
            "existingGroupings": "Regroupements au niveau des champs",
            "extraGroupings": "Regroupement supplémentaire",
            "apiGroupings": "Regroupements des éléments API",
            "groupBy": "Regrouper par ce champ",
            "hasGrouping": "Le résultat sera regroupé par ce champ",
            "runStartEndTitle": "Définir l'exécution début-fin",
            "selectTag": "Sélectionner une balise",
            "defineStartEnd": "Définir l'exécution début-fin",
            "start": "Démarrer la transaction",
            "end": "Terminer la transaction",
            "deleteDependency": "Supprimer la dépendance",
            "fail": "échoue",
            "success": "s'exécute avec succès",
            "condition": "Condition",
            "selectTransaction": "Transaction",
            "dependency": "Exécuter \"{apiLabel}\" si",
            "updateDependency": "Dépendances",
            "deleteOutput": "Supprimer la sortie - ce champ ne sera plus disponible dans les recherches",
            "addOutput": "Ajouter une sortie - ce champ sera disponible dans les recherches",
            "sources": {
                "CONSTANT": "Constante",
                "CLIENT": "Client",
                "API": "API",
                "EXCEL": "Excel",
                "TEXT": "Texte",
                "EVENT": "Événement",
                "CONTEXT": "Contexte",
                "TAG": "Balise",
                "CURRENT_DATE": "Date actuelle",
                "_": "Aucun"
            },
            "openFieldConfig": "Ouvrir la configuration du mappage des paramètres",
            "client": "Prendre la valeur depuis",
            "newClientField": "Nouveau champ client",
            "showGeneralTransactions": "Inclure les transactions générales",
            "parameterRequiredAndNotMapped": "Paramètre obligatoire mais non mappé",
            "parameterNotRequiredAndNotMapped": "Paramètre non obligatoire et non mappé",
            "apiCall": "Appel API",
            "output": "Paramètre de sortie",
            "mappedOutputHeader": "Sortie mappée",
            "selectApiFirst": "Sélectionner d'abord une API",
            "constantValue": "Valeur constante",
            "constantValueRequired": "Une valeur constante est requise",
            "tagRequired": "Une balise est requise",
            "availableSources": "Sources disponibles",
            "selectSource": "Sélectionner une source",
            "removeSource": "Supprimer la source",
            "sourceTitle": "Configuration du champ pour {name}",
            "copyPrefix": " (copie %n)",
            "deleteApiConfirmation": "Êtes-vous sûr de vouloir supprimer l'appel API ?",
            "deleteApiHeader": "Suppression de l'appel API",
            "source": "Source",
            "value": "Valeur",
            "m3Company": "Société M3",
            "m3Division": "Division M3",
            "maxRows": "Nombre maximum de lignes",
            "unlimited": "Illimité",
            "companyMustBeNumeric": "La société M3 doit être une valeur numérique",
            "executionConfig": "Configuration de l'exécution",
            "name": "Nom",
            "configureExecution": "Configurer l'exécution",
            "addFirstApi": "Cliquez ici pour ajouter le premier appel API",
            "noEnvironmentSelected": "Aucun environnement sélectionné",
            "selectEnvironment": "Sélectionner un environnement",
            "transactionSelectTitle": "Sélectionner la transaction à exécuter",
            "program": "Programmes",
            "selectProgram": "Sélectionner d'abord un programme",
            "transaction": "Transactions",
            "copy": "Copier",
            "setCritical": "Définir comme critique",
            "unsetCritical": "Retirer le statut critique",
            "inputsHeader": "Entrées",
            "outputHeader": "Sorties",
            "addItem": "Ajouter un élément API à cette position",
            "eventColumn": "Event column",
            "title": "API M3",
            "selected": "sélectionné"
        },
        "execute": {
            "advanced": "Avancée",
            "browse": "Parcourir",
            "chooseTheFile": "Choisissez un fichier",
            "dropTheFile": "Déposez le fichier ici...",
            "logLevel": "Bûche Niveau",
            "logLevelList": {
                "detailed": "Détaillé",
                "failures": "Les échecs",
                "info": "Info"
            },
            "result": {
                "done": "Fait",
                "duration": "Durée",
                "failedRecords": "Enregistrements échoués:",
                "files": "Fichiers",
                "recordsProcessed": "Dossiers traités:",
                "stepId": "Étape ID",
                "success": "Étape réussie:",
                "successfulRecords": "Enregistrements réussis:",
                "title": "Résultats",
                "trigger": "Trigger File",
                "waitingToStart": "En attente de démarrage",
                "workflowEnded": "Flux de travail terminé",
                "workflowFailed": "Flux de travail échoué!",
                "workflowRunning": "Flux de travail courant...",
                "workflowRunningInBackground": "Flux de travail est encore courant en le arrière plan. (Bientôt, vous pourrez voir le journal d'exécution pour toutes les exécutions)",
                "workflowStarted": "Flux de travail démarré",
                "failedToDownloadTriggerFile": "Échec du téléchargement du fichier déclencheur",
                "noTriggerFile": "Aucun fichier déclencheur disponible"
            },
            "schedule": {
                "daily": {
                    "day": "day",
                    "title": "Daily"
                },
                "day": "Day",
                "every": "Every",
                "everyWeekDay": "Every week day",
                "hourly": {
                    "hour": "hour",
                    "title": "Hourly"
                },
                "minutes": {
                    "minutes": "minutes",
                    "title": "Minutes"
                },
                "monthly": {
                    "month": "month",
                    "title": "Monthly"
                },
                "monthsOptions": {
                    "april": "April",
                    "august": "August",
                    "december": "December",
                    "february": "February",
                    "january": "January",
                    "july": "July",
                    "june": "June",
                    "march": "March",
                    "may": "May",
                    "november": "November",
                    "october": "October",
                    "september": "September"
                },
                "of": "of",
                "ofEvery": "of every",
                "periodOptions": {
                    "first": "First",
                    "fourth": "Fourth",
                    "second": "Second",
                    "third": "Third"
                },
                "scheduler": "Scheduler",
                "startTime": "Start time",
                "the": "The",
                "weekly": {
                    "friday": "Friday",
                    "monday": "Monday",
                    "saturday": "Saturday",
                    "sunday": "Sunday",
                    "thursday": "Thursday",
                    "title": "Weekly",
                    "tuesday": "Tuesday",
                    "wednesday": "Wednesday"
                },
                "yearly": {
                    "title": "Yearly"
                }
            }
        },
        "export": "Exportation",
        "failure": "Échec",
        "fileLoader": {
            "fileLoader": "File Loader",
            "messages": {
                "info": "If the folder has multiple files, the most recently edited will be picked by default",
                "missingConnection": "FILE LOADER: Please select a connection",
                "missingFile": "FILE LOADER: Please select a file"
            }
        },
        "filter": {
            "action": "Action",
            "all": "All",
            "field": "Champ",
            "fieldSource": {
                "constant": "Constant",
                "fromClient": "From Client"
            },
            "filterConditions": {
                "blank": "Is Blank",
                "contains": "Contains",
                "doesNotContain": "Does Not Contain",
                "equal": "Equal",
                "greaterThan": "Greater Than",
                "greaterThanEqual": "Greater than Equal",
                "lessThan": "Less Than",
                "lessThanEqual": "Less than Equal",
                "notBlank": "Is Not Blank",
                "notEqual": "Not Equal"
            },
            "filterConfiguration": "Configuration du filtre",
            "logicalType": " Type logique",
            "logicalTypes": {
                "and": "AND",
                "or": "OR"
            },
            "messages": {
                "mapOneFieldFilter": "FILTRE M3 : Mappez au moins un champ pour que le filtre fonctionne",
                "missingConstantValue": "FILTER: Missing value for Constant in {filterDescription}",
                "missingLogicalType": "FILTER: Missing Logical Type for {filterDescription}",
                "missingSource": "FILTER: Missing source for {filterDescription}",
                "missingType": "FILTER: Missing Type for {filterDescription}"
            },
            "noApiFound": "Aucune API trouvée",
            "selectFields": "Sélectionnez les champs",
            "source": "La source",
            "type": "Type"
        },
        "filterText": "Filtre",
        "filters": "Filtres",
        "import": "Importer",
        "inputFields": "Champs de saisie",
        "invalidWorkflow": "Flux de travail non valide",
        "lastExecuted": "Dernière exécution",
        "logLevel": "Bûche Niveau",
        "logLevelList": {
            "detailed": "Détaillé",
            "failures": "Échec",
            "info": "Info"
        },
        "logs": {
            "AvgTimePerRecord": "AvgTimePerRecord",
            "AvgTimePerTransaction": "AvgTimePerTransaction",
            "action": "Action",
            "auditLogs": "Audit Logs",
            "downloadDataContents": "Télécharger le contenu des données",
            "durationMs": "Durée (ms)",
            "endTime": "Fin",
            "environmentLogs": {
                "rerunEnvironment": {
                    "title": "Confirm Re-run"
                }
            },
            "fails": "Échec",
            "joblog": "Journal des tâches",
            "logDetails": "Bûche détails",
            "logType": "Bûche Type",
            "logTypeList": {
                "all": "Tous",
                "failed": "Échoué",
                "ok": "Succès",
                "verified": "Vérifié",
                "retried": "Réessayé",
                "started": "Démarré"
            },
            "logs": "Journaux",
            "message": "Message",
            "program": "Programme",
            "startTime": "Début",
            "status": "Statut",
            "success": "Succès",
            "time": "Time",
            "title": "Journaux de flux de travail",
            "transaction": "Transaction",
            "type": "Type",
            "rerun": "Ré-exécuter le workflow",
            "verify": "Marquer comme vérifié",
            "resultJson": {
                "errorTitle": "Échec du téléchargement des détails du résultat",
                "download": "Télécharger les détails du résultat",
                "copyToClipboard": "Copier dans le presse-papiers",
                "copySuccessMessage": "Détails du résultat copiés dans le presse-papiers",
                "copyErrorMessage": "Erreur lors de la copie des détails du résultat dans le presse-papiers"
            },
            "findOriginal": "Trouver l'original"
        },
        "manual": "Manuel",
        "messages": {
            "configureOneComponent": "Please configure at least one component",
            "couldNotSaveWorkflow": "Impossible d'enregistrer le flux de travail!",
            "enterNotificationEmail": "Please enter notification Email",
            "enterValidWorkflow": "Veuillez saisir un nom de workflow valide",
            "errorOccured": "Une erreur s'est produite lors de l'exécution du workflow!",
            "executionComplete": "Exécution terminée!",
            "fileNotFound": "File or directory not found. Please check if the uploaded file exists or has been renamed.",
            "invalidGenericFilter": "Veuillez sélectionner le type logique pour toutes les lignes du filtre générique",
            "invalidValue": "Valeur invalide {input} pour le terrain {field}.",
            "m3APIMaxRowAlertText": "Si vous souhaitez plus de 99 999 enregistrements, cochez la case \"Illimité\".",
            "mandatoryField": "Veuillez saisir le champ obligatoire {field}.",
            "maxValueExceed": "Valeur {input} pour le terrain {field} a dépassé la longueur maximale {length}.",
            "permissionError": "L’utilisateur/rôle n’a pas les autorisations pour {errorMessage}",
            "schdulerSavedWithErrors": "Une erreur s'est produite dans la configuration du planificateur",
            "schedulerDelete": "Planificateur supprimé avec succès",
            "schedulerErrorAlertText": "{input} a des valeurs manquantes",
            "schedulerSavedSuccessfully": "Planificateur configuré avec succès",
            "specialCharError": "Caractère spécial / $ * ? {'{ }'} [ ] n'est pas autorisé dans le nom du flux de travail",
            "workflowNameExists": "Le nom du workflow {workflowName} existe déjà!",
            "workflowNameRequired": "Workflow name is required",
            "workflowSavedSuccessfully": "Workflow enregistré avec succès!",
            "workflowSavedWithErrors": "Workflow enregistré avec les erreurs suivantes:"
        },
        "modifiedBy": "Modified by",
        "name": "Nom",
        "navguardWarning": "You seem to have unsaved changes that will be lost if you leave this page. Do you wish to discard the changes and continue?",
        "newWorkflow": "Nouveau Workflow",
        "deleteWorkflow": "Supprimer le workflow",
        "deactivateWorkflow": {
            "header": "Désactiver le workflow",
            "message": "La désactivation de ce workflow arrêtera également les exécutions planifiées.",
            "confirm": "Oui, désactiver"
        },
        "workflowActivatedSuccess": "Workflow activé avec succès",
        "workflowDeactivatedSuccess": "Workflow désactivé avec succès",
        "groups": "groupes",
        "group": "groupe",
        "labels": "Étiquettes",
        "label": "étiquette",
        "executionKeys": "Clés d'exécution",
        "executionLogs": "Journaux d'exécution",
        "notificationEmail": "E-mail pour les rapports d'erreur",

        "notifyOnErrorTooltip": "Notifie le(s) destinataire(s) à chaque erreur",

        "notificationEmailHint": "Saisissez une ou plusieurs adresses e-mail, séparées par une virgule. Utilisé à la fois pour les notifications d'erreur lorsque « Notifier en cas d'erreur » est coché, et pour les erreurs générales telles que plusieurs échecs lors d'exécutions planifiées.",
        "notifyOnError": "Notifier en cas d'erreur",
        "addActive": "Ajouter la sélection",
        "addAllActive": "Ajouter tout",
        "removeActive": "Supprimer la sélection",
        "removeAllActive": "Supprimer tout",
        "moveUp": "Déplacer l'élément sélectionné vers le haut",
        "moveTop": "Déplacer l'élément sélectionné en haut",
        "moveDown": "Déplacer l'élément sélectionné vers le bas",
        "moveBottom": "Déplacer l'élément sélectionné en bas",
        "outputFields": "Champs de sortie",
        "preview": "Aperçu",
        "previewData": "Aperçu Les données",
        "recentlyViewed": "Vu récemment",
        "favorite": "Ajouter aux favoris",
        "unfavorite": "Retirer des favoris",
        "favorites": "Favoris",
        "restApi": {
            "restApiConfiguration": "Rest API"
        },
        "runBy": "Run by",
        "scheduled": "Programmé",
        "select": "sélectionner",
        "settings": {
            "retryAttemptsNegetiveNumberValidation": "Ne doit pas être inférieur à 0.",
            "retryAttemptsPositiveNumberValidation": "Ne devrait pas dépasser la limite 5."
        },
        "sms": {
            "maxlengthWarning": "{messageLength}/160 caractères",
            "messages": {
                "contentMaxLengthError": "SMS: content cannot exceed 160 characters",
                "invalidRecipientNumber": "Numéro de téléphone invalide",
                "noContentError": "SMS: Content field cannot be blank",
                "noRecipientsError": "SMS: Recipients cannot be empty"
            },
            "recipientsLabel": "Entrez le numéro de téléphone du destinataire",
            "recipientsPlaceholder": "+1234567890",
            "smsConfiguration": "SMS Configuration",
            "smsContentPlaceholder": "Enter the message",
            "smsLabel": "Message",
            "saveMessage": "Enregistrer le message"
        },
        "status": {
            "active": "Actif",
            "all": "Tout",
            "inactive": "Inactif",
            "title": "Statut"
        },
        "success": "Succès",
        "table": {
            "columnName": "Nom de colonne",
            "columnToLeft": "Ajouter une colonne à gauche",
            "columnToRight": "Ajouter une colonne à droite",
            "customTableConfig": "Configuration de table personnalisée",
            "dataType": "Type de données",
            "deleteCell": "Supprimer la cellule",
            "deleteContent": "Supprimer le contenu",
            "fieldName": "Nom de domaine",
            "messages": {
                "missingPrimaryKey": "TABLE: Table is missing Primary key",
                "missingRecordCreationType": "TABLE: Table is missing Record Creation type",
                "missingTableName": "TABLE: Missing Table name",
                "tableNameExists": "TABLE: Le nom de la table existe déjà",
                "tableNameError": "TABLE: Nom manquant",
                "tableDescriptionError": "TABLE: Description manquante",
                "tableColumnError": "TABLE: Colonne manquante"
            },
            "primaryKey": "Clé primaire",
            "recordTypeList": {
                "append": "Append",
                "replace": "Replace",
                "upsert": "Upsert"
            },
            "removeField": "Supprimer le champ",
            "removePrimaryKey": "Supprimer la clé primaire",
            "selectFields": " Sélectionnez les champs",
            "setPrimaryKey": "Définir la clé primaire",
            "tableAlias": "Table Alias",
            "tableDescription": "Description de la table",
            "tableName": "Nom de la table",
            "tableRecordType": "Type de création d'enregistrement",
            "tableSettings": "Paramètres de table",
            "showRecentWorkflows": "Afficher les workflows récemment consultés",
            "hideRecentWorkflows": "Masquer les workflows récemment consultés",
            "sortByFavorites": "Trier par favoris",
            "clearFavoriteSort": "Effacer le tri des favoris"
        },
        "tableUpdater": {
            "messages": {
                "noTableSelectedWarning": "Table Updater: Please select a table.",
                "stepInfo": "Please note that the output from the previous step needs to have the keys marked with (P)."
            },
            "selectTableLabel": "Select a table",
            "tableUpdaterConfiguration": "Table updater"
        },
        "converter": {
            "saveAsFile": "Enregistrer également la sortie en fichier"
        },
        "title": "Flux de travail",
        "transform": {
            "transformConfiguration": "Transform",
            "trimAllInputValues": "Trim all input values before transformation"
        },
        "m3filter": {
            "newValue": "Valeur",
            "newConstant": "Nouveau",
            "noM3ApiItems": "Aucun élément de filtre disponible sans API M3 définie",
            "dragItems": "Le filtre ne contient actuellement aucun élément.",
            "clickToShow": "Cliquez ici pour afficher la liste des champs disponibles",
            "dropBelow": "Faites glisser l'élément ci-dessous pour ajouter un filtre",
            "filterItems": "Éléments de filtre",
            "globalFilter": "Filtre global",
            "constant": "Constante",
            "defaultValue": "Valeur par défaut",
            "valueSourceOptions": {
                "CLIENT": "Client",
                "CONSTANT": "Constante"
            },
            "comparisonOptions": {
                "EQ": "Égal",
                "NE": "Différent",
                "LT": "Inférieur à",
                "GT": "Supérieur à",
                "LE": "Inférieur ou égal",
                "GE": "Supérieur ou égal",
                "BLANK": "Vide",
                "NOTBLANK": "Non vide",
                "CONTAINS": "Contient",
                "NOTCONTAINS": "Ne contient pas"
            },
            "source": "Source",
            "logicalOperator": "Opérateur logique",
            "comparison": "Comparaison",
            "title": "Filtre",
            "openFields": "Afficher les champs disponibles",
            "closeFields": "Fermer la liste des champs",
            "constantValueRequired": "Une valeur constante est requise pour le champ : {field}",
            "noFieldsMappedWarning": "Aucun champ n'est mappé. Veuillez mapper au moins un champ pour le filtre M3 ou supprimer le filtre M3.",
            "noFieldsMappedError": "FILTRE M3 : Aucun champ n'est mappé"
        },
        "trigger": {
            "apiSettingDetails": "Détails des paramètres de l’API",
            "templateName": "Nom du modèle",
            "buttonLabel": "Libellé du bouton",
            "buttonPreview": "Aperçu",
            "dropArea": "Zone de glisser-déposer pour {group}",
            "emptyDropArea": "Glisser-déposer",
            "allFieldsAssigned": "Tous les champs disponibles ont été attribués.",
            "removeFieldToMakeAvailable": "Supprimez un champ pour le rendre à nouveau disponible.",
            "allFiltersAssigned": "Tous les filtres disponibles ont été attribués.",
            "removeFilterToMakeAvailable": "Supprimez un filtre pour le rendre à nouveau disponible.",
            "lookupConfig": "Configurer les recherches",
            "clientPreview": "Aperçu client",
            "lookupAlreadyExists": "Un déclencheur avec ce nom de recherche existe déjà. Veuillez en choisir un autre.",
            "lookupNameRequired": "Le nom de la recherche est requis",
            "selectNewWorkflow": "Sélectionnez un nouveau flux de travail pour le déclencheur",
            "selectSource": "Sélectionner la source",
            "lookupNotAvailable": "La recherche n'est pas disponible. Le flux de travail est introuvable ou inactif.",
            "workflowNotFound":"Le flux de travail sélectionné n'est pas disponible. Veuillez choisir un nouveau flux de travail.",
            "noClientInputs": "Aucune entrée client n'est configurée pour ce flux de travail. Veuillez ajouter au moins une entrée client pour configurer un déclencheur.",
            "actions": "Actes",
            "actionsRequired": "Actions is a mandatory field",
            "messages": {
                "triggerType": "TRIGGER: Please select a Trigger Type"
            },
            "title": "Trigger",
            "triggerConfiguration": "Trigger Configuration",
            "filtering": "Filtrage",
            "filterTooltip": "Vous ne pouvez utiliser que Filtre ou Expression. En choisir un exclut l'autre",
            "emptyFilterPlaceholder": "Aucun filtre ou expression n'est appliqué. Cliquez sur Filtres ou Expression pour créer une condition. En choisir un éliminera l'autre",
            "addFilter": "Ajouter un filtre",
            "maximizeEditor": "Maximiser l'éditeur",
            "invalidExpression": "Expression JSONata invalide",
            "events": {
                "FILTER": "Filtre",
                "EXPRESSION": "Expression"
            },
            "nextRuns": "Prochaines exécutions planifiées",
            "start": "Date et heure de début",
            "end": "Date et heure de fin",
            "scheduledWorkflowRuns": "Exécutions planifiées du flux de travail",
            "scheduleDescription": "Veuillez indiquer la fréquence d'exécution souhaitée du flux de travail",
            "scheduledRuns": "Exécutions planifiées",
            "noScheduledRuns": "Aucune exécution planifiée",
            "clearSelection": "Effacer la sélection",
            "replaceNotAvailable": "Les événements de déclenchement ne sont pas disponibles pour REPLACE",
            "noEventColumnsAvailable": "No event columns available. Please configure an Event trigger with columns first."
        },
        "updateUserInstructions": "Mise à jour",
        "userInstructions": "Instructions d'utilisation",
        "saveUserInstructions": "Instructions enregistrées avec succès",
        "value": "Valeur",
        "version": "Version",
        "searchEnvironments": "Search environments",
        "loadErrorEnvironments": "Échec du chargement des environnements",
        "loadErrorEnvironmentsPermission": "Vous n'avez pas la permission de charger les environnements. Veuillez contacter votre administrateur.",
        "loadErrorConnections": "Échec du chargement des connexions",
        "loadErrorConnectionsPermission": "Vous n'avez pas la permission de charger les connexions. Veuillez contacter votre administrateur.",
        "templates": {
            "exportToExcel": {
                "title": "Export from M3 API",
                "description": "Export from a M3 API through a filter into a table"
            },
            "importToApi": {
                "title": "Import to M3 API",
                "description": "Import from the M3 API into a table"
            },
            "apiToTable": {
                "title": "Store data from M3 to Table",
                "description": "Export from the M3 API into a table"
            },
            "onAPI": {
                "title": "M3 API",
                "description": "Connect directly to the M3 API"
            },
            "transform": {
                "title": "Transform",
                "description": "Process and transform data between systems"
            },
            "empty": {
                "title": "Blank Start",
                "description": "Build a workflow from scratch"
            }
        },
        "templateGroups": {
            "multi": "Multi Component Templates",
            "single": "Single Component Templates"
        },
        "nameAndDescription": "Details",
        "template": "Templates",
        "labels": "Etiketter",
        "addLabel": "Add a Label",
        "workflowInfo": "Workflow Info",
        "configuration": "Configuration",
        "options": "Options",
        "widget": {
            "addNewState": "Ajouter un nouvel état",
            "additionalInfo": "Color for foreground text and icon",
            "aggregateType": "Type d'agrégat",
            "backgroundColor": "Background color",
            "color": "Couleur",
            "count": "compter",
            "createWidget": "Créer un widget",
            "customBackgroundColor": "Custom background color",
            "dashboardUpdateInterval": "Intervalle de mise à jour du tableau de bord (secondes)",
            "data": "data",
            "dataCount": "Taille de police pour le nombre de données",
            "defaultBackgroundColor": "Default background color",
            "deleteDraft": "Supprimer le brouillon",
            "displayValue": "Valeur d'affichage",
            "documentation": "Documentation",
            "editState": "Modifier l'état",
            "fontSize": "Taille de police",
            "foregroundColor": "Text color",
            "icon": "Icône",
            "iconSettings": "Icon settings",
            "interval": "Intervalle",
            "label": "Étiquette",
            "labelsMax": "Étiquettes (max 25)",
            "max": "Max",
            "min": "Min",
            "newState": "Nouvel état",
            "noStatesDefined": "Aucun état n'est défini",
            "normalized": "Normalisé",
            "pollingCountWithoutChanges": "Nombre d'interrogations sans modifications avant l'avertissement",
            "range": "Intervalle",
            "rangeFrom": "Intervalle de",
            "rangeTo": "Intervalle",
            "scales": "Balance",
            "selectWidgetType": "Sélectionnez le type de widget",
            "show": "Spectacle",
            "sortBy": "Trier par",
            "stacked": "Empilé",
            "states": "États",
            "tableName": "Tableaux personnalisés",
            "titleSize": "Taille de police pour le titre",
            "type": "Type",
            "viewDetails": "Voir les détails",
            "widgetField": "Champ",
            "widgetTitle": "Titre",
            "xAxisConfigure": "Configurer X-Axis",
            "yAxisConfigure": "Configurer Y-Axis"
        },
        "workflow": "Flux de travail",
        "workflowActions": {
            "downloadTemplate": "Télécharger le modèle",
            "execute": "Exécuter",
            "log": "enregistrer",
            "manageRoles": "Gérer les rôles",
            "move": "bouge toi",
            "reRun": "Re-run",
            "rename": "Renommer",
            "run": "Run",
            "schedule": "Programme"
        },
        "workflowDescription": "description du workflow",
        "copyInfo": "Vous pouvez soit modifier le nom du workflow, soit utiliser le nom suggéré pour continuer.",
        "copyWorkflow": "Copier le workflow",
        "enterCopyName": "Nom du workflow",
        "nameExists": "Nom du workflow déjà utilisé. Veuillez choisir un nom unique.",
        "copySuccess": "Le workflow '{name}' a été copié avec succès.",
        "copyError": "Échec de la copie du workflow.",
        "workflowName": "Nom du workflow",
        "workflowType": "Workflow Type",
        "workflowTypeOptions": {
            "EXPRESS": "Express",
            "STANDARD": "Volume élevé"
        },
        "useDedicatedIP": "Utiliser une IP dédiée",

        "ignoreExportMi": "Ignorer les recherches EXPORTMI",
        "longRunning": "Longue exécution",
        "longRunningMessage": "Gère les charges de travail longues et à haute capacité",
        "expressMessage": "Convient pour les opérations rapides, mais peut échouer lors de charges de travail longues ou importantes en raison des limites de temps d'exécution.",
        "longRunningTooltip": "Activez pour les grandes importations Excel (30 000+ lignes) qui peuvent dépasser 15 minutes."
    },
    "workflowStatistics": {
        "statistics": "Statistiques du workflow",
        "lastExecutionTime": "Dernière exécution",
        "lastSuccessfulTime": "Dernière réussite",
        "lastFailedTime": "Dernier échec",
        "totalRuns": "Exécutions totales",
        "totalRunsTooltip": "Nombre total d'exécutions du workflow",
        "successfulRunsTooltip": "Exécutions réussies du workflow",
        "failedRunsTooltip": "Échecs d'exécution du workflow",
        "viewLog": "Voir le journal"
    },
    "workflowMonitoring": {
        "title": "Surveillance des workflows",
        "description": "Suivez les exécutions en échec, puis vérifiez-les ou réessayez-les",
        "refresh": "Actualiser",
        "tryAgain": "Réessayer",
        "loadError": "Impossible de charger les exécutions",
        "workflowsLoadError": "Impossible de charger les workflows",
        "searchPlaceholder": "Rechercher par workflow, ID d'exécution ou clé",
        "workflowFilter": {
            "label": "Workflow",
            "placeholder": "Tous les workflows",
            "errorCount": "{count} erreurs"
        },
        "showRetried": "Afficher les réessayées",
        "showVerified": "Afficher les vérifiées",
        "timeRange": "Période",
        "days": "{count} jours",
        "truncated": "Affichage des {shown} exécutions les plus récentes sur {total}. Choisissez une période plus courte pour toutes les voir.",
        "noRunPermission": "Vous n'avez pas l'autorisation d'exécuter ce workflow",
        "kpis": {
            "unhandledErrors": "Erreurs non traitées",
            "lastDays": "{days} derniers jours",
            "affectedWorkflows": "Workflows concernés",
            "affectedWorkflowsDescription": "Workflows avec des erreurs",
            "hoursSinceLastError": "Heures depuis la dernière erreur",
            "hoursSinceLastErrorDescription": "Depuis le dernier échec",
            "avgErrorsPerDay": "Erreurs par jour",
            "avgErrorsPerDayDescription": "Sur la période"
        },
        "chart": {
            "title": "Erreurs non traitées par workflow",
            "hint": "Cliquez sur un workflow pour voir ses exécutions en échec",
            "other": "Autres",
            "tooltip": "{count} erreurs ({percent} %)",
            "noErrors": "Aucune erreur non traitée"
        },
        "columns": {
            "workflowTime": "Workflow / heure",
            "workflow": "Workflow"
        },
        "errorsList": {
            "title": "Exécutions en erreur",
            "workflowTitle": "Exécutions de {name}",
            "count": "{shown} affichée(s) ({total} au total)"
        },
        "empty": {
            "noErrors": "Aucune erreur au cours des {days} derniers jours",
            "allHandled": "Toutes les erreurs sont traitées. Utilisez Afficher les réessayées ou Afficher les vérifiées pour les voir.",
            "noMatches": "Aucune exécution ne correspond aux filtres",
            "noWorkflowExecutions": "Aucune exécution de ce workflow au cours des {days} derniers jours"
        },
        "selection": {
            "selected": "{count} sélectionnée(s) sur {max} maximum",
            "limitReached": "Vous pouvez sélectionner jusqu'à {max} exécutions à la fois"
        },
        "actions": {
            "retry": "Réessayer",
            "verify": "Marquer comme vérifié",
            "advancedResend": "Modifier les données et renvoyer",
            "openFullPage": "Ouvrir la page complète",
            "openLogs": "Ouvrir les journaux du workflow",
            "notAvailable": "Les détails ne sont pas disponibles pour les exécutions de plus de 3 mois."
        },
        "confirm": {
            "retryTitle": "Réessayer les exécutions",
            "verifyTitle": "Marquer les exécutions comme vérifiées",
            "retryMessage": "Réessayer {count} exécution(s) ? Chacune relance son workflow avec les données d'origine.",
            "verifyMessage": "Marquer {count} exécution(s) comme vérifiée(s) ?",
            "nonFailedWarning": "{count} d'entre elles n'ont pas échoué, et les relancer peut répéter ce qu'elles ont fait.",
            "noPermissionSkipped": "{count} exécution(s) sont ignorées, car vous ne pouvez pas exécuter leur workflow."
        },
        "results": {
            "retried": "{count} exécution(s) relancée(s)",
            "verified": "{count} exécution(s) marquée(s) comme vérifiée(s)",
            "failed": "{count} exécution(s) en échec : {message}",
            "nothingToDo": "Vous ne pouvez pas exécuter les workflows des exécutions sélectionnées",
            "unknownError": "Une erreur s'est produite"
        },
        "details": {
            "title": "Détails de l'exécution",
            "executionId": "ID d'exécution",
            "notifyOnError": "Notification d'erreur",
            "keys": "Clés d'exécution",
            "error": "Détails de l'erreur",
            "trigger": "Données du déclencheur",
            "triggerFile": "Cette exécution a démarré avec le fichier déclencheur {file}.",
            "loadError": "Impossible de charger les détails de l'exécution"
        },
        "advancedResend": {
            "title": "Modifier les données et renvoyer",
            "description": "Modifiez les données du déclencheur, puis relancez le workflow avec celles-ci. L'exécution d'origine est marquée comme réessayée.",
            "payloadLabel": "Données du déclencheur (JSON)",
            "invalidJson": "JSON non valide : {message}",
            "notAnObject": "Les données doivent être un objet ou un tableau JSON",
            "triggerFileNotice": "L'exécution d'origine utilisait un fichier déclencheur. Les données modifiées sont envoyées à la place de ce fichier.",
            "reset": "Rétablir l'original",
            "submit": "Renvoyer",
            "success": "L'exécution a été renvoyée avec les données modifiées"
        }
    }
}
